import store from '../../store'
import axios from 'axios'

export default async() => {
    let responseData;
    let defaultLanguage = '';
    let headerMenuData = {}

    if (store.state.defaultLanguage !== null) {
        defaultLanguage = (store.state.defaultLanguage).toLowerCase();
    }

    await axios({
        url: window.cipConfig.VUE_APP_API_ENDPOINT + "app/missions/explore",
        method: 'get',
        headers: {
            'X-localization': defaultLanguage,
        }
    })
      .then((response) => {
          // Set header menu data
          if (response.data.data) {
              headerMenuData.top_theme = response.data.data.top_themes;
              headerMenuData.top_country = response.data.data.top_countries;
              headerMenuData.top_organization = response.data.data.top_organization;
          }
          store.commit('headerMenu', headerMenuData);
      })
      .catch(function() {});
    return responseData;
}